/* eslint-disable dot-notation */
/* eslint-disable import/prefer-default-export */

import { AlertSeverityEnum } from '@src/endpoints/services/commonHdr.service'

const filterByAlertSeverity = <T extends { severity?: AlertSeverityEnum }>(
  data: T[] = [],
  severity: AlertSeverityEnum
) => data.filter(item => item.severity === severity)

export const separateDataBySeverity = <T>(data: T[]) => {
  const redList = filterByAlertSeverity(
    data,
    AlertSeverityEnum.ALERT_SEVERITY_HIGH
  )
  const orangeList = filterByAlertSeverity(
    data,
    AlertSeverityEnum.ALERT_SEVERITY_MEDIUM
  )
  const yellowList = filterByAlertSeverity(
    data,
    AlertSeverityEnum.ALERT_SEVERITY_LOW
  )

  return { redList, orangeList, yellowList }
}
